module.exports = __webpack_public_path__ + "img/溫室內感測器.377af8d0.jpg";